<h1 mat-dialog-title class="{{titleClass}}">
  {{title}}
</h1>

<div mat-dialog-content class="{{messageClass}}">
  <p>{{message}}</p>
</div>

<div mat-dialog-actions class="divider-horiz-top-dotted-full-width">
  <button mat-button (click)="onDismiss()">No</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
</div>